import PropTypes from 'prop-types';

import PropTypesPresenter from '../../utils/PropTypesPresenter';
import DatePresenter from '../../presenters/DatePresenter';

const PENDING = 'pending';

export default new PropTypesPresenter(
  {
    id: PropTypes.string,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    amountDue: PropTypes.number,
    state: PropTypes.string,
    invoiceNumber: PropTypes.number,
    invoicePdfUrl: PropTypes.string,
  },
  {
    periodReadable(invoice) {
      const startDate = DatePresenter.readableFormattedDate(
        this.startDate(invoice)
      );
      const endDate = DatePresenter.readableFormattedDate(
        this.endDate(invoice)
      );
      return `${startDate} - ${endDate}`;
    },
    isPending(invoice) {
      return this.state(invoice) === PENDING;
    },
    amountDueReadable(invoice) {
      const amountDue = this.amountDue(invoice).toFixed(2);
      return `$${amountDue}`;
    },
  }
);
